module.exports = __webpack_public_path__ + "img/student5.54bf95cf.jpg";